export enum FadeDirection { FADE_IN, FADE_OUT }
